import { getExtremumX, getExtremumY } from "./extremums.js";
import seriesProcessor from "./seriesProcessor.js";
import getColor from "./getColor.js";
import legendGetter from "./legend.js";
import tooltipGetter from "./tooltip.js";
import getSeriesWithDefaultValues from "./getSeriesWithDefaultValues.js";
import tooltipItemPositionGetter from "./tooltipPosition.js";
import keyboardFocusHandler from "./keyboardFocusHandler.js";
import { identifierSerializerSeriesIdDataIndex } from "../../internals/identifierSerializer.js";
export const scatterSeriesConfig = {
  seriesProcessor,
  colorProcessor: getColor,
  legendGetter,
  tooltipGetter,
  tooltipItemPositionGetter,
  xExtremumGetter: getExtremumX,
  yExtremumGetter: getExtremumY,
  getSeriesWithDefaultValues,
  keyboardFocusHandler,
  identifierSerializer: identifierSerializerSeriesIdDataIndex
};